"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmptyListItem = exports.isEmptyListItem = exports.emptyListItem = void 0;
exports.emptyListItem = { empty: true };
/**
 * @public
 */
exports.isEmptyListItem = function (item) {
    return item && item.empty;
};
/**
 * @public
 */
exports.isNonEmptyListItem = function (item) {
    return item && !item.empty;
};
//# sourceMappingURL=types.js.map